import React from 'react';
import { useTheme } from 'styled-components';
import { IconProps } from './types';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function AddressBookIcon({ color: colorProp }: IconProps) {
  const theme = useTheme();

  const color = colorProp || theme.colors.chartChartBlueSecondary2100;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 9H5.5C4.11875 9 3 10.1187 3 11.5C3 11.775 3.225 12 3.5 12C3.775 12 4 11.775 4 11.5C4 10.6719 4.67188 10 5.5 10H7.5C8.32844 10 9 10.6716 9 11.5C9 11.7761 9.22388 12 9.5 12C9.77616 12 10 11.7761 10 11.5C10 10.1187 8.88125 9 7.5 9ZM14.5 6H14V9H14.5C14.775 9 15 8.775 15 8.5V6.5C15 6.225 14.775 6 14.5 6ZM6.5 8C7.60469 8 8.5 7.10469 8.5 6C8.5 4.89531 7.60469 4 6.5 4C5.39531 4 4.5 4.89531 4.5 6C4.5 7.10469 5.39687 8 6.5 8ZM6.5 5C7.05125 5 7.5 5.44875 7.5 6C7.5 6.55125 7.05125 7 6.5 7C5.94875 7 5.5 6.55125 5.5 6C5.5 5.44875 5.95 5 6.5 5ZM14.5 10H14V13H14.5C14.7762 13 15 12.7761 15 12.5V10.5C15 10.225 14.775 10 14.5 10ZM14.5 2H14V5H14.5C14.775 5 15 4.775 15 4.5V2.5C15 2.22375 14.775 2 14.5 2ZM11 0H2C0.895313 0 0 0.895313 0 2V14C0 15.1047 0.895313 16 2 16H11C12.1047 16 13 15.1047 13 14V2C13 0.895313 12.1031 0 11 0ZM12 14C12 14.5513 11.5513 15 11 15H2C1.44875 15 1 14.5513 1 14V2C1 1.44875 1.44875 1 2 1H11C11.5513 1 12 1.44875 12 2V14Z"
        fill={color}
      />
    </svg>
  );
}

export default AddressBookIcon;
